import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import logo from '../assets/logo.png';
import { FaUserShield } from 'react-icons/fa';
import './Header.css';

export default function Header({ user }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error cerrando sesión:', error);
      alert('No se pudo cerrar sesión. Intenta de nuevo.');
    }
  };

  const isAdmin = user?.email === 'duxbyteinformatica@gmail.com';

  return (
    <header className="header">
      <div className="header-container">

        {/* === IZQUIERDA: LOGO === */}
        <div className="header-left">
          <Link to="/">
            <img src={logo} alt="Logo de Duxbyte" className="logo" />
          </Link>
        </div>

        {/* === CENTRO: NAVEGACIÓN === */}
        <div className="header-center">
          <nav className="header-nav">
            <Link to="/" className="nav-link">Inicio</Link>
            <Link to="/servicios" className="nav-link">Servicios</Link>
            <Link to="/sobre-nosotros" className="nav-link">Sobre Nosotros</Link>
            <Link to="/contacto" className="nav-link">Contacto</Link>
          </nav>
        </div>

        {/* === DERECHA: BOTONES === */}
        <div className="header-right">
          {/* Mostrar botón solo si NO es administrador */}
          {!isAdmin && (
            <Link to="/solicitar-diagnostico" className="btn-diagnostic btn-wide">
              Solicitar Diagnóstico
            </Link>
          )}

          {/*
          {user ? (
            <div className="account-actions">
              {isAdmin && (
                <Link to="/admin" title="Zona Administrador" className="admin-icon">
                  <FaUserShield className="icon-admin-green" />
                </Link>
              )}
              <Link to="/area-cliente" className="btn-manage btn-wide">Gestionar Cuenta</Link>
              <button className="btn-logout btn-wide" onClick={handleLogout}>Cerrar sesión</button>
            </div>
          ) : (
            <Link to="/login" className="btn-login btn-wide">Mi cuenta</Link>
          )}
          */}
        </div>

      </div>
    </header>
  );
}
